import { RouteObject } from "react-router-dom";
import { PageNotFound } from "../app/404";
import { DownloadBackUpCodes } from "../app/_admin/auth/downloadBackUpCodes";
import { InitiateTwoFaPage } from "../app/_admin/auth/initiateTwoFa";
import { AdminLoginPage } from "../app/_admin/auth/login";
import { TwoFaPage } from "../app/_admin/auth/twoFa";
import { EventsPage } from "../app/_admin/events";
import { AdminViewSingleEvent } from "../app/_admin/events/view";
import { HolidaysPage } from "../app/_admin/holidays";
import { ProfilePage } from "../app/_admin/profile";
import { RevenuesPage } from "../app/_admin/revenue";
import { SalesPage } from "../app/_admin/sales";
import { SingleSalesAgentPage } from "../app/_admin/sales/salesAgent";
import { SettingsPage } from "../app/_admin/settings";
import { UsersPage } from "../app/_admin/users";
import { SingleUserPage } from "../app/_admin/users/singleUser";
import { ErrorPage } from "../app/error";
import { AdminAppLayout } from "../components/layout/adminAppLayout";
import { AdminAuthLayout } from "../components/layout/adminAuthLayout";
import { AdminProtected } from "../components/layout/protected";
import { TwoFaProtected } from "../components/layout/twoFaProtected";
import { OverviewPage } from "../app/_admin/overview";
import { MonthlyRevenuePage } from "../app/_admin/revenue/monthlyRevenue";

export const adminRouter: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <AdminAuthLayout>
            <AdminLoginPage />
          </AdminAuthLayout>
        ),
      },
      {
        path: "login",
        element: (
          <AdminAuthLayout>
            <AdminLoginPage />
          </AdminAuthLayout>
        ),
      },
      {
        path: "verify-2fa/:id",
        element: (
          <AdminAuthLayout>
            <TwoFaProtected>
              <TwoFaPage />
            </TwoFaProtected>
          </AdminAuthLayout>
        ),
      },
      {
        path: "initiate-2fa/:id",
        element: (
          <AdminAuthLayout>
            <TwoFaProtected>
              <InitiateTwoFaPage />
            </TwoFaProtected>
          </AdminAuthLayout>
        ),
      },
      {
        path: "backup-codes",
        element: (
          <AdminAuthLayout>
            <TwoFaProtected>
              <DownloadBackUpCodes />
            </TwoFaProtected>
          </AdminAuthLayout>
        ),
      },
      {
        path: "overview",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <OverviewPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "users",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <UsersPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "users/:id",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <SingleUserPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "events",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <EventsPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "events/:id",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <AdminViewSingleEvent />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "events/:id/guest/:guestId",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <AdminViewSingleEvent guestView />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "overview/revenue",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <RevenuesPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "overview/revenue/:monthId/:yearId",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <MonthlyRevenuePage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "profile",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <ProfilePage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "admin/settings",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <SettingsPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "public/holidays",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <HolidaysPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "sales",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <SalesPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
      {
        path: "sales/agent/:id",
        element: (
          <AdminAppLayout>
            <AdminProtected>
              <SingleSalesAgentPage />
            </AdminProtected>
          </AdminAppLayout>
        ),
      },
    ],
  },

  {
    path: "*",
    element: (
      <AdminAppLayout>
        <PageNotFound />
      </AdminAppLayout>
    ),
  },
];
